var _style, _path, _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpidIdpEtnaid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 497.18 115.91",
    style: {
      enableBackground: "new 0 0 497.18 115.91"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#232047;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:url(#SVGID_00000137105590030749206080000017972388735083613116_);}\n\t.st3{fill:url(#SVGID_00000098222935259553767280000003557927504018722944_);}\n\t.st4{fill:url(#SVGID_00000026867617625195999970000015909112118534587057_);}\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.14,79.03c0.08-8.58,5.73-14.88,12.58-16.73c2.01-0.54,4.05-0.76,6.12-0.51c1.19,0.14,2.39,0.21,3.59,0.17 c4.37-0.14,8.35-1.48,11.91-4.01c1.07-0.76,2.05-1.64,2.98-2.57c0.88-0.89,1.72-1.8,2.46-2.81c2.04-2.76,3.34-5.84,3.94-9.22 c0.4-2.25,0.42-4.51,0.13-6.77c-0.17-1.36-0.12-2.72,0.07-4.06c0.39-2.76,1.37-5.29,3-7.56c2.62-3.66,6.13-6,10.54-6.88 c7.52-1.49,14.69,2.11,18.22,8.51c1.21,2.19,1.91,4.54,2.07,7.04c0.33,5.14-1.26,9.6-4.83,13.3c-2.51,2.6-5.58,4.21-9.14,4.85 c-1.64,0.3-3.28,0.33-4.94,0.16c-5.03-0.51-9.73,0.45-14.05,3.13c-1.49,0.92-2.83,2.03-4.06,3.28c-0.73,0.75-1.45,1.49-2.1,2.31 c-2.29,2.9-3.74,6.18-4.38,9.82c-0.34,1.93-0.41,3.87-0.22,5.82c0.16,1.56,0.23,3.12,0.03,4.68c-0.33,2.48-1.1,4.8-2.43,6.93 c-2.53,4.06-6.13,6.68-10.8,7.73c-5.96,1.34-12.02-0.64-16.09-5.03c-2.4-2.6-3.87-5.65-4.4-9.16 C19.22,80.58,19.18,79.72,19.14,79.03z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 62.3113,
    y1: 78.5951,
    x2: 97.0651,
    y2: 78.5951
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F5AC28"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EB752A"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 79.69,
    cy: 78.6,
    r: 17.38
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000143616047899482958750000007232680994048206475_",
    gradientUnits: "userSpaceOnUse",
    x1: 19.0469,
    y1: 35.3307,
    x2: 53.8006,
    y2: 35.3307
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F5AC28"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EB752A"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000143616047899482958750000007232680994048206475_)"
    },
    cx: 36.42,
    cy: 35.33,
    r: 17.38
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M145.83,31.89c14.23,0,33.4,10.69,30.5,36.83h-49.55c1.93,10.57,10.13,16.39,20.62,16.39 c6.63,0,12.42-1.9,17.36-5.7l7.35,6.89c-5.91,6.53-14.23,9.74-25.08,9.74c-5.43,0-10.61-1.07-15.55-3.33 C121.71,88.08,114,77.74,114,64.08c0-10.33,4.34-19.13,10.61-24.23C131,34.74,138.59,31.89,145.83,31.89z M145.83,42.94 c-8.68,0-17,5.94-18.93,16.27h37.74c-0.6-5.11-2.77-9.15-6.51-12C154.39,44.36,150.29,42.94,145.83,42.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M218.29,33.55v10.69h-13.26v34.57c0,3.92,1.93,5.82,5.91,5.82c2.29,0,4.7-0.47,7.35-1.43v10.57 c-3.01,1.54-6.63,2.26-10.85,2.26c-9.65,0-15.43-3.8-15.43-14.37V44.24h-8.68V33.55h8.68v-15.8h13.02v15.8H218.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M263.75,33.08c6.51,0,12.06,2.26,16.64,6.89c4.58,4.63,6.87,11.4,6.87,20.31v35.76h-13.02V60.99 c0-11.05-6.27-16.63-14.95-16.63c-4.82,0-8.8,1.66-11.94,4.99c-3.01,3.21-4.82,6.53-5.18,9.74v36.94h-13.02V34.27h13.02V47.1 C243.49,43.53,250,33.08,263.75,33.08z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M328.02,96.04c-7.23,0-14.71-2.73-20.86-7.84c-6.15-5.11-10.25-13.9-10.25-24.23 c0-10.33,4.1-19.13,10.25-24.23c6.15-5.11,13.62-7.84,20.86-7.84c10.01,0,17.96,5.46,20.86,11.29h0.72v-10.1h13.02v61.77H349.6 v-10.1h-0.72C345.98,90.57,338.02,96.04,328.02,96.04z M329.7,84.63c5.43,0,10.13-1.78,14.11-5.46c4.1-3.68,6.15-8.67,6.15-15.21 c0-6.53-2.05-11.52-6.15-15.21c-3.98-3.68-8.68-5.46-14.11-5.46c-5.3,0-10.01,1.78-14.11,5.46c-3.98,3.68-6.03,8.67-6.03,15.21 c0,6.53,2.05,11.52,6.03,15.21C319.7,82.85,324.4,84.63,329.7,84.63z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000174564669243997489670000010594038130461497732_",
    gradientUnits: "userSpaceOnUse",
    x1: 379.2711,
    y1: 56.8945,
    x2: 395.8427,
    y2: 56.8945
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F5AC28"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EB752A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000174564669243997489670000010594038130461497732_)"
    },
    d: "M379.27,17.75h16.57v78.28h-16.57V17.75z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152242750934432597500000015354428214167774133_",
    gradientUnits: "userSpaceOnUse",
    x1: 409.4651,
    y1: 56.8945,
    x2: 478.1378,
    y2: 56.8945
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F5AC28"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EB752A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000152242750934432597500000015354428214167774133_)"
    },
    d: "M409.47,17.75h28.38 c11.24,0,20.77,3.8,28.6,11.41c7.83,7.49,11.69,16.66,11.69,27.29c0,11.07-3.86,20.47-11.69,28.18 c-7.83,7.61-17.37,11.41-28.6,11.41h-28.38V17.75z M426.04,80.6h11.69c7.38,0,13.05-2.24,17.14-6.82c4.2-4.58,6.24-10.4,6.24-17.33 c0-6.6-2.04-12.08-6.24-16.55c-4.2-4.47-9.87-6.71-17.14-6.71h-11.69V80.6z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpidIdpEtnaid);
export default __webpack_public_path__ + "static/media/spid-idp-etnaid.875f4590985aa590f2fa59929a062502.svg";
export { ForwardRef as ReactComponent };